export const SERVER_API_URL = 'https://vinhomes365-api.991991.eu.cc/api/'
export const UPLOAD_API_URL = 'https://image.991991.eu.cc';
export const SYNCFUSION_COMMUNITY_KEY =
  'Ngo9BigBOggjHTQxAR8/V1NHaF5cXmpCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdgWH9fdnVTQ2VcUEZxVkQ=';
export const SOCKET_URL = 'wss://vinhomes365-api.991991.eu.cc';


// export const SERVER_API_URL = 'http://localhost:8088/api/';
// export const UPLOAD_API_URL = 'https://upload.crmservice.online';
// export const SYNCFUSION_COMMUNITY_KEY =
//   'Ngo9BigBOggjHTQxAR8/V1NHaF5cXmpCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdgWH9fdnVTQ2VcUEZxVkQ=';
// export const SOCKET_URL = 'ws://localhost:8088';